import React from 'react';
import { ShieldAlert, X } from 'lucide-react';
import { Button } from './button';

const BeautifiedErrorAlert = ({ error, onDismiss }) => {
    if (!error) return null;

    // Check if error is a list (e.g. from validation "Field: error; Field: error")
    const isList = typeof error === 'string' && error.includes('; ');
    const errorList = isList ? error.split('; ') : [error];

    return (
        <div className="bg-white dark:bg-slate-900 border-l-4 border-l-red-500 dark:border-l-red-400 border border-slate-100 dark:border-slate-700 shadow-xl rounded-xl p-4 flex items-start justify-between gap-4 animate-in fade-in slide-in-from-top-2 duration-300 mb-4 max-w-4xl relative overflow-hidden">
            <div className="flex gap-3 w-full z-10">
                <div className="text-red-500 dark:text-red-400 mt-0.5">
                    <ShieldAlert className="h-5 w-5" />
                </div>
                <div className="flex-1">
                    <h4 className="text-sm font-black tracking-tight text-slate-900 dark:text-slate-100 mb-1 uppercase tracking-widest opacity-80">Action Required</h4>
                    {isList ? (
                        <ul className="text-sm text-slate-600 dark:text-slate-300 space-y-1 list-disc list-inside font-medium">
                            {errorList.map((err, idx) => (
                                <li key={idx} className="marker:text-red-500 dark:marker:text-red-400">
                                    {err}
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-sm text-slate-600 dark:text-slate-300 font-bold leading-relaxed">
                            {typeof error === 'object' ? JSON.stringify(error) : error}
                        </p>
                    )}
                </div>
            </div>

            {onDismiss && (
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={onDismiss}
                    className="h-6 w-6 hover:bg-gray-100 dark:hover:bg-zinc-800 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 -mt-1 -mr-1"
                >
                    <X className="h-4 w-4" />
                </Button>
            )}
        </div>
    );
};

export default BeautifiedErrorAlert;
